import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Analytics } from './analytics';
import { AutomationStatusBanner } from './automation-status-banner';
import { ChannelsSection } from './channels-section';
import { GeneralRecommendation } from './general-recommendations';
import { PostingUnavailableBanner } from './posting-unavailable-banner';

function ChannelsContent() {
  return (
    <>
      <PostingUnavailableBanner />
      <AutomationStatusBanner />
      <Analytics />
      <GeneralRecommendation />
      <ChannelsSection />
      <Outlet />
    </>
  );
}

export function Channels() {
  return (
    <Suspense fallback={<Channels.Skeleton />}>
      <ChannelsContent />
    </Suspense>
  );
}

Channels.Skeleton = function ChannelsSkeleton() {
  return (
    <>
      <Analytics.Skeleton />
      <ChannelsSection.Skeleton />
    </>
  );
};
